<template>
  <v-card class="memberManagement" flat>
    
    <AdminToolbar
      :label="'YYYY-mm-dd YYYY-mm-dd'"
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getMembers" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>會員</v-col>
        <v-col>編號</v-col>
        <v-col>本名</v-col>
        <v-col>手機</v-col>
        <v-col>Email</v-col>
        <v-col>身分認證</v-col>
        <v-col>建立時間</v-col>
        <v-col>最後上線時間</v-col>
        <v-col>目前桃子</v-col>
        <v-col>總儲值桃子</v-col>
        <v-col>VIP等級</v-col>
        <v-col>消費明細</v-col>
        <v-col>停用狀態</v-col>
        <v-col style="min-width: 50px; max-width: 50px"></v-col>
      </v-row>

      <div class="table-body">
        <template v-for="member in members">
          <v-row class="table-content" no-gutters>
            <v-col>
              <v-avatar size="40" class="mr-2">
                <v-img :src="$HOST_URL + member.usericon"/>
              </v-avatar>
              {{ member.nickname }}
            </v-col>
            <v-col>
              {{ member.id | member }}
            </v-col>
            <v-col>
              {{ member.last_name }}{{ member.first_name }}
            </v-col>
            <v-col>
              {{ member.tel }}
            </v-col>
            <v-col>
              {{ member.email }}
            </v-col>
            <v-col>
              <v-icon v-if="member.identity_verified" color="success">fa-check</v-icon>
              <v-icon v-else color="red">fa-times</v-icon>
            </v-col>
            <v-col>
              {{ member.created_at | formatDate }}
            </v-col>
            <v-col>
              
            </v-col>
            <v-col>
              {{ member.peach }}
            </v-col>
            <v-col>
              {{ member.peach_bought }}
            </v-col>
            <v-col>
              {{ member.vip_level }}
            </v-col>
            <v-col>
              <router-link to="/admin/member">查看</router-link>
            </v-col>
            <v-col>
              <v-btn
                v-if="member.disabled" 
                icon 
                color="red" 
                @click="$refs.reasonDialog.submit(reason => ban(member, false, reason))"
              >
                <v-icon >fa-ban</v-icon>
              </v-btn>
              <v-btn
                v-else
                icon 
                color="success" 
                @click="$refs.reasonDialog.submit(reason => ban(member, true, reason))"
              >
                <v-icon>fa-check</v-icon>
              </v-btn>
            </v-col>
            <v-col style="min-width: 50px; max-width: 50px">
              <v-btn icon color="indigo" :to="`/admin/member/${member.id}`">
                <v-icon>fa-edit</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
    <ReasonDialog ref="reasonDialog"></ReasonDialog>
  </v-card>
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
import AdminToolbar from '@/components/admin/AdminToolbar'
import ReasonDialog from '@/components/ReasonDialog'
export default {
  components: { DeleteConfirmBtn, AdminToolbar, ReasonDialog },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '建立日期', table: 'members', column: 'created_at' },
      ],
      sortTypes: [],
      sort: '',
      tabs: [],
      tab: 0,
      search_condition: [],
      members: []
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.members = []
      this.getMembers()
    },
    getMembers() {
      this.busy = true
      this.axios.get(`/admin/members?page=${this.page}&size=50${this.search_condition.length ? `&start=${this.search_condition[0].keyword.split(' ')[0]}&end=${this.search_condition[0].keyword.split(' ')[1]}` : ''}`).then(response => {
        this.members = this.members.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    ban(member, disabled, reason) {
      this.axios.post(`${disabled ? '/admin/ban' : '/admin/lift/ban'}`,{
        type: 'member',
        id: member.id,
        reason: reason
      }).then(response => {
        member.disabled = !member.disabled
        this.$root.$emit('alert', 'success', '修改成功')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '修改失敗')
      })
    }
  }
}
</script>

<style lang="scss">
.memberManagement {
 
}
</style>